import { useState, useEffect,useContext } from "react";
import { openDB } from "idb";
import { v4 as uuidv4 } from "uuid";
import ItemGroupingTable from "./ItemGroupingTable";
import AddButton from "./AddButton";
import SetupModal from "./SetupModal";
import ItemsForm from "./ItemsForm";
import styles from "../css/SetupForm.module.css";
import Context from "../context/context";
const DEFAULT_ITEM_GROUPINGS = [
  {
    item_group_uuid: "item-group-uuid-1",
    item_group_title: "My first item group",
    items: ["item-uuid-1", "item-uuid-2"],
  },
];

export default function ItemGroupingForm({ onSave }) {
  const [itemGroupings, setItemGroupings] = useState(DEFAULT_ITEM_GROUPINGS);
  const [itemsModalIndex, setItemsModalIndex] = useState(null);
const context = useContext(Context);
const { updateUnSync } = context;

  useEffect(() => {
    const asyncfunc = async () => {
      const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
      const itemGroupingStore = db
        .transaction("item_grouping", "readonly")
        .objectStore("item_grouping");
      const itemGroupings = await itemGroupingStore.getAll();
      setItemGroupings(itemGroupings);
    }
    asyncfunc();
  }, []);

  const addTableItem = () =>
    setItemGroupings([
      ...itemGroupings,
      {
        item_group_uuid: uuidv4(),
        item_group_title: "",
        items: [],
      },
    ]);

  const handleGroupEdit = (index) => (event) => {
    setItemsModalIndex(index);
  };

  const handleSubmit = async () => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const itemGroupingStore = db
      .transaction("item_grouping", "readwrite")
      .objectStore("item_grouping");
    await itemGroupingStore.clear();
    await Promise.all(
      itemGroupings.map(async (itemGroup) => {
        const data = {
          ...itemGroup,
          outlet_uuid:localStorage.getItem("outlet_uuid"),
          IDENTIFIER: itemGroup.item_group_uuid,
        };
        await itemGroupingStore.put(data);
        handleItemGroupUnsyncedFile(data);
      })
    );
    onSave();
  };

  // Adding/Editing item group to unsynced_files collection in IndexedDB
  const handleItemGroupUnsyncedFile = async (data) => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = await db
      .transaction("unsynced_files", "readwrite")
      .objectStore("unsynced_files");
    const ndata = {
      // IDENTIFIER: "item_grouping",
      ...data,
      RECON_TIME: Date.now(),
      IDENTIFIER: "item_grouping:"+data.IDENTIFIER,
      // item_group: data.itemGroup
    };
    await tx.put(ndata);
    handleItemGroupReconciliation(ndata);
    updateUnSync()
  };

  // Adding/Editing item group to reconciliation collection in IndexedDB
  const handleItemGroupReconciliation = async (data) => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = await db
      .transaction("reconciliation", "readwrite")
      .objectStore("reconciliation");
    const allReconRecords = await tx.getAll();

    const othersJsonExists = allReconRecords.find(
      (curr) => curr.IDENTIFIER === "item_grouping"
    );
    if (othersJsonExists) {
      const invoice = othersJsonExists?.details?.filter(
        (entry) => entry.item_group_uuid !== data.item_group_uuid
      );
      const editData = {
        ...othersJsonExists,
        details: [
          ...invoice,
          {
            type: "item_group",
            RECON_TIME: data.RECON_TIME,
            item_group_uuid: data.item_group_uuid,
          },
        ],
      };
      await tx.put(editData);
    } else {
      const newdata = {
        IDENTIFIER: "item_grouping",
        details: [
          {
            type: "item_group",
            RECON_TIME: data.RECON_TIME,
            item_group_uuid: data.item_group_uuid,
          },
        ],
      };
      await tx.add(newdata);
    }
  };

  return (
    <div className={styles.form}>
      <div className={styles.heading}>
        <h1>Item Grouping</h1>
      </div>

      <div className={styles.formContainer}>
        <ItemGroupingTable
          itemGroupings={itemGroupings}
          setItemGroupings={setItemGroupings}
          onGroupEdit={handleGroupEdit}
        />

        <AddButton onClick={addTableItem} />

        <button type='button' onClick={handleSubmit} className={styles.submit}>
          Save changes
        </button>
      </div>
      {itemsModalIndex !== null && (
        <SetupModal onClose={() => setItemsModalIndex(null)}>
          <ItemsForm
            itemGroupings={itemGroupings}
            setItemGroupings={setItemGroupings}
            itemGroupingIndex={itemsModalIndex}
            setItemsModalIndex={setItemsModalIndex}
          />
        </SetupModal>
      )}
    </div>
  );
}
